module.exports = __webpack_public_path__ + "media/images/logo_with_name-adeb241708ecbc7e2e59769bbf1cb03e.png";